import { motion } from 'framer-motion';
import { Apple, Download } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section id="cta-final" data-testid="final-cta-section" className="py-24 sm:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/assets/img/final-cta-bg.png"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/90 to-[#0D0D0D]/70" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-white font-['Poppins'] font-bold text-3xl sm:text-4xl lg:text-5xl mb-4"
        >
          Prêt à améliorer votre{' '}
          <span className="gradient-text">score</span> ?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-[#A0A0A0] text-base sm:text-lg mb-10 max-w-lg mx-auto"
        >
          Rejoignez des milliers de tireurs qui progressent avec ClayPulse
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="/ios"
            data-testid="final-cta-appstore"
            className="pulse-cta inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#FF8A5B] text-white font-semibold text-base hover:shadow-[0_0_30px_rgba(255,107,53,0.4)] transition-all duration-300 hover:scale-105"
          >
            <Apple size={20} />
            App Store
          </a>
          <a
            href="/android"
            data-testid="final-cta-android"
            className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full border border-white/10 bg-white/5 text-white font-semibold text-base hover:bg-white/10 hover:border-[#FF6B35]/30 transition-all duration-300 hover:scale-105"
          >
            <Download size={20} />
            APK Android
          </a>
        </motion.div>
      </div>
    </section>
  );
}
